import { lazy } from 'react';

import { createBrowserHistory, History } from 'history';
import ROUTE_PATHS from 'micro-merchant/config/routes/route-paths';

export const history: History = createBrowserHistory();

const Routes = [
  {
    path: ROUTE_PATHS.preload,
    component: lazy(() => import('micro-merchant/@pages/preload.page')),
  },

  {
    path: ROUTE_PATHS.authentication,
    component: lazy(() => import('micro-merchant/@pages/authentication')),
  },

  {
    path: ROUTE_PATHS.authorize,
    component: lazy(() => import('micro-merchant/@pages/authorize')),
  },

  {
    path: ROUTE_PATHS.profile,
    component: lazy(() => import('micro-merchant/@pages/merchant-profile/profile.page')),
  },

  {
    path: ROUTE_PATHS.identityValidation,
    component: lazy(
      () => import('micro-merchant/@pages/merchant-profile/identity-validation.page'),
    ),
  },

  {
    path: ROUTE_PATHS.success,
    component: lazy(() => import('micro-merchant/@pages/success.page')),
  },

  {
    path: ROUTE_PATHS.error,
    component: lazy(() => import('micro-merchant/@pages/error.page')),
  },
];

export default Routes;
